// extracted by mini-css-extract-plugin
module.exports = {"typer":"Navigation_typer__HSa37"};